export class TbaValidationErrorResponse {
  name: any;
  transactionType: any;
  tbaEvaluationMethod: any;
}
